<script setup lang="ts">
import type { ItemDisplayMode } from "@/stores/Settings";
import DRTileItem from "./DRTileItem.vue";
import DRLineItem from "./DRLineItem.vue";

defineProps<{
  display: ItemDisplayMode;
  selected?: boolean;
  title?: string;
  subtitle?: string;
  mini?: boolean;
  extended?: boolean;
}>();

defineEmits<{
  "update:extended": [value: boolean];
}>();
</script>

<template>
  <div>
    <DRTileItem
      v-if="display === 'card'"
      :selected="selected"
      :mini="mini"
      :subtitle="subtitle"
      :title="title"
      :extended="extended"
      @update:extended="$emit('update:extended', $event)"
    >
      <template #icon>
        <slot name="icon" :size="40"></slot>
      </template>
      <template #title>
        <slot name="title"></slot>
      </template>
      <template #subtitle>
        <slot name="subtitle"></slot>
      </template>
      <template #more>
        <slot name="more"></slot>
      </template>
      <template #actions>
        <slot name="actions"></slot>
      </template>
      <template #footer>
        <div
          class="d-flex pb-2 gap-2 align-items-center justify-content-between"
        >
          <slot name="append1"></slot>
          <slot name="append2"></slot>
        </div>
      </template>
      <template #extended>
        <slot name="extended"></slot>
      </template>
    </DRTileItem>

    <DRLineItem
      v-if="display === 'line'"
      :selected="selected"
      :mini="mini"
      :subtitle="subtitle"
      :title="title"
      :extended="extended"
    >
      <template #icon>
        <slot name="icon" :size="30"></slot>
      </template>
      <template #title>
        <slot name="title"></slot>
      </template>
      <template #subtitle>
        <slot name="subtitle"></slot>
      </template>
      <template #more>
        <slot name="more"></slot>
      </template>
      <template #actions>
        <slot name="append1"></slot>
        <slot name="append2"></slot>
        <slot name="actions"></slot>
      </template>
      <template #extended>
        <slot name="extended"></slot>
      </template>
    </DRLineItem>
  </div>
</template>

<style lang="scss" scoped></style>
